import {
  skuIsLoadedOrUnloadedVehicleSpecificEnclosure
} from '../../helpers/products/vehicle-specific.mjs';
import {skuToVsMappings} from '../../helpers/search/search-functions.mjs';

export const refineMeiliResults = (searchInfo, searchResults, filterResults) => {
  // console.dir({searchInfo, searchResults, filterResults}, {depth: null})
  const query = (searchInfo?.query || '').toLowerCase();

  const carMakes = Object.values(skuToVsMappings);
  let uniqueCarMakes = [...new Set(carMakes)];
  uniqueCarMakes = uniqueCarMakes.map(make => make.toLowerCase());
  const regex = new RegExp(`(\\b\\d{2,4}\\b).+?\\b(${uniqueCarMakes.join("|")})\\b`, "i");
  let match = regex.exec(query);

  if (match) {
    const year = match[1] ? normalizeYear(match[1]) : null;
    const make = match[2] ? match[2] : null;

    if(year && make) {
      const justMatchingVehicles = filterOnlyYearAndMake(searchResults, year, make);
      // console.log({justMatchingVehicles})
      return justMatchingVehicles
    }
  }

  const filters = [
    {queries: ['vehicle', 'vehicle specific'], filterFunction: filterForVehicleSpecific},
    {queries: ['door speaker', 'door speakers'], filterFunction: filterOut4DoorItems},
    {queries: ['bass knob'], filterFunction: filterForOnlyBassKnobs},
    {
      queries: ['6x9', '4x8', '6x8', '4x6', '3.5', 'marine speaker', 'marine speakers'],
      filterFunction: filterForOnlySpeakers
    },
    {queries: ['box', 'enclosure', 'subwoofer box'], filterFunction: filterForBestBoxResults},
    {queries: ['dual', 'triple', 'quad'], filterFunction: filterForOnlyEnclosures},
    {
      queries: ['amp', 'ampl', 'ampli', 'amplif', 'amplifi', 'amplifie', '5 channel', '5-channel', 'marine amplifier', 'marine amp'],
      filterFunction: filterForAmplifiers
    },
    {
      queries: ['10', '10 inch', '10 in', '10"', '12', '12 inch', '12 in', '12"', '15', '15 inch', '15 in', '15"', '18', '18 inch', '18 in', '18"'],
      filterFunction: filterForSubAndSpeakerSize
    },
    {
      queries: ['bundle', 'bundles', 'kits', 'kit'],
      filterFunction: filterForOnlyCompleteBassPackages
    },
    {queries: ['big 3'], filterFunction: filterForOnlyBig3},
    {queries: ['6.5'], filterFunction: filterForOnlySpeakersAndSubwoofers},
    {queries: ['marine subwoofer', 'marine sub'], filterFunction: filterForOnlyMarineSubwoofers}
  ];

  for (const filter of filters) {
    if (filter?.queries?.some(q => query === q)) {
      // console.log(`[RefineMeiliResults]: Filtering for ${filter.queries.join(", ")}`);
      searchResults = filter?.filterFunction(searchResults, query);
      break;
    }
  }

  searchResults = filterForExactSKU(searchResults, query);

  // Optional sorting by totalTurn30
  // results = results.sort((a, b) => b.totalTurn30 - a.totalTurn30);
  return searchResults;
};

export const filterOnlyYearAndMake = (results, queryYear, queryMake) => {
  const matchingVehicles = results?.filter((searchResult) => {
    const specs = searchResult?.specs;
    const startYear = specs?.startYear;
    const endYear = specs?.endYear
    const make = specs?.make?.toLowerCase();
    const isMatch = startYear <= queryYear && endYear >= queryYear && make === queryMake

    if (isMatch) {
      return true;
    }
  });

  return matchingVehicles;
}

export const filterForVehicleSpecific = (results) => {
  return results?.filter((searchResult) => {
    const sku = searchResult?.sku;
    const isVehicleSpecific = skuIsLoadedOrUnloadedVehicleSpecificEnclosure(sku);
    // console.log({sku, isVehicleSpecific})
    return isVehicleSpecific;
  });
};


export const filterForOnlyBig3 = (results) => {
  return results?.filter((searchResults) => {
    if (searchResults?.sku === 'SKBIG3-0GA' || searchResults?.sku === 'SKBIG3-4GA') return true;
  });
};

export const filterForOnlyCompleteBassPackages = (results) => {
  return results?.filter((searchResults) => {
    if (searchResults?.category === 'complete-bass-package') return true;
  });
};

export const filterForSubAndSpeakerSize = (results, query) => {
  const querySize = parseFloat(query);

  return results?.filter((searchResults) => {
    const size = parseFloat(searchResults?.specs?.size?.replace(/[^0-9.]/g, ''));

    if (size === querySize) return true;
  });
};

export const filterForOnlySpeakersAndSubwoofers = (results) => {
  return results?.filter((searchResult) => {
    return searchResult?.category === 'speakers' || searchResult?.category === 'subwoofers';
  });
};

export const filterForOnlyMarineSubwoofers = (results) => {
  return results?.filter((searchResult) => {
    return searchResult?.category === 'marine-subwoofers';
  });
};

export const filterForAmplifiers = (results) => {
  return results?.filter((searchResult) => {
    return searchResult?.category === 'amplifiers';
  });
};

export const filterForBestBoxResults = (results) => {
  return results?.filter((searchResult) => {
    // console.log({searchResult})
    const sku = searchResult?.sku;
    if (!sku) return;

    const isLoadedEnclosure = searchResult?.category === 'loaded-subwoofer-enclosures';
    // console.log({isLoadedEnclosure})
    if (isLoadedEnclosure) return false;

    return true;
  });
};

export const filterForOnlyEnclosures = (results) => {
  return results?.filter((searchResult) => {
    // console.log({searchResult})
    const sku = searchResult?.sku;
    if (!sku) return;

    return searchResult?.category === 'loaded-subwoofer-enclosures' ||
      searchResult?.category === 'empty-subwoofer-enclosures';
  });
};

export const filterOut4DoorItems = (results) => {
  const regex = new RegExp('4[-\\s]?door', 'i');
  return results?.filter((searchResult) => {
    const name = searchResult?.name;
    const has4Door = regex.test(name);
    return !has4Door;
  });
};

export const filterForExactSKU = (results, query) => {
  const lowerCaseQuery = query?.toLowerCase();

  const product = results?.find((searchResult) => {
    const sku = searchResult?.sku;
    const variantSkus = searchResult?.variantSkus || [];

    const hasExactSKU = sku ? sku.toLowerCase() === lowerCaseQuery : false;
    const matchedVariantSKU = variantSkus?.find(
      (variantSku) => variantSku?.toLowerCase() === lowerCaseQuery
    );

    const hasMultipleVariantSkus = variantSkus?.length > 1;

    if (matchedVariantSKU && hasMultipleVariantSkus) {
      updateSlugWithVariant(searchResult, matchedVariantSKU);
    }

    return hasExactSKU || matchedVariantSKU;
  });

  if (product && skuIsLoadedOrUnloadedVehicleSpecificEnclosure(product?.sku)) {
    return findMatchingEnclosureProduct(product, results);
  }

  return product ? [product] : results;
};

const findMatchingEnclosureProduct = (product, results) => {
  const sku = product?.sku;
  if (sku) {
    let matchingEnclosureProduct;
    if (sku.endsWith('-V')) {
      const skuWithoutV = sku.slice(0, -2);
      matchingEnclosureProduct = results?.find(
        (result) => result?.sku === skuWithoutV
      );
    } else {
      const skuWithV = sku + '-V';
      matchingEnclosureProduct = results?.find(
        (result) => result?.sku === skuWithV
      );
    }

    if (matchingEnclosureProduct) {
      updateSlugWithVariant(matchingEnclosureProduct, matchingEnclosureProduct?.sku);
      return [product, matchingEnclosureProduct];
    }
  }
  return [product];
};


const updateSlugWithVariant = (searchResult, matchedVariantSKU) => {
  const variantSkus = searchResult?.variantSkus || [];
  const hasMultipleVariantSkus = variantSkus?.length > 1;

  if (matchedVariantSKU && hasMultipleVariantSkus) {
    const url = new URL(searchResult?.slug, 'https://www.skaraudio.com');
    if (!url.searchParams.has('variant') && !url.searchParams.has('sku')) {
      url.searchParams.append('variant', matchedVariantSKU);
      searchResult.slug = url.pathname + url.search;
    }
  }
};

export const filterForOnlyBassKnobs = (results) => {
  return results?.filter((searchResult) => {
    const sku = searchResult?.sku;
    if (!sku) return;

    const isBassKnob = sku?.includes('BASS CTRL PKG') || sku?.includes('SK-RBVM');
    return isBassKnob;
  });
};

export const filterForOnlySpeakers = (results) => {
  return results?.filter((searchResult) => {
    return searchResult?.category === 'speakers';
  });
};

export const normalizeYear = (year) => {
  year = parseInt(year)
  if (year >= 0 && year <= 70) {
    // If the year is between 0 and 21, assume it's in the 2000s.
    return 2000 + year;
  } else if (year >= 70 && year <= 99) {
    // If the year is between 22 and 99, assume it's in the 1900s.
    return 1900 + year;
  } else {
    // If the year is already a 4-digit number, return it as is.
    return year;
  }
}
